<template>
  <div>
    <div class="row pb-3 border-bottom border-danger">
      <div class="w-100 text-center mt-3">
        <h3>POLAND ORDERS HISTORY</h3>
      </div>
      <div class="w-30 mr-3">
        <span>Order Closed Date:</span>
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="startDate" class="text-dark"></datepicker>
      </div>
      <div class="w-20 mt-4">
        <button @click="getOrders" :class="!startDate ? 'btn-outline-danger disabled' : 'btn-success'" class="btn px-5 py-2">
          SEARCH <b-icon-search shift-h="10"></b-icon-search>
        </button>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div v-if="data.length">
      <div class="row mt-3 overflow-auto">
        <div class="col-12">
          <table class="table" ref="articles">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Added</th>
              <th scope="col">SKU</th>
              <th class="d-none d-sm-table-cell" scope="col">SSKU</th>
              <th class="d-none d-sm-table-cell" scope="col">Factory #</th>
              <th class="d-none d-sm-table-cell" scope="col">Ordered</th>
              <th class="d-none d-sm-table-cell" scope="col">Scanned</th>
              <th class="d-none d-sm-table-cell text-center" scope="col">Ordered For</th>
              <th class="d-none d-sm-table-cell" scope="col">Notes</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(val, i) of data">
              <tr v-if="val.border" class="separator" :key="`conditional-${i}`">
                <td colspan="9" class="w-100 bg-dark">
                  <span>Ordered by: <span class="text-uppercase">{{val.fromWeb ? 'website' : val.user && val.user.username || 'Lyngdal'}}</span></span>
                  <span v-if="val.fromWeb && val.deliveryMethod" class="ml-3 float-right">Delivery method: {{val.deliveryMethod.name}}</span>
                </td>
              </tr>
              <tr :key="i" :class="val.border ? `${getRowClass(val)}` : getRowClass(val)">
                <td :style="scanned.code && val.ean && val.ean.includes(scanned.code) ? 'background: #dc3545; color: #ffffff' : ''">{{i+1}}</td>
                <th scope="row">{{moment(val.addedAt).format('DD.MM.YYYY')}}</th>
                <td>{{val.sku}}</td>
                <td>{{val.ssku}}</td>
                <td>{{val.num}}</td>
                <td class="text-center">{{val.count}}</td>
                <td class="text-center">{{val.confirmed || 0}}</td>
                <td class="text-center">{{val.metaData || 'WORKSHOP'}}</td>
                <td v-b-tooltip.hover.left="val.notes ? stripHtmlTags(val.notes) : ''" class="text-center" @click="openNotes(val)">
                  <b-icon icon="pencil-square" class="pointer"></b-icon>
                </td>
              </tr>
            </template>

            </tbody>
          </table>
        </div>
      </div>
<!--      <div class="row overflow-hidden d-flex">-->
<!--        <div class="col-md-6 col-sm-6 ml-auto">-->
<!--          <table class="table font-weight-bolder float-right">-->
<!--            <tr>-->
<!--              <td>TOTAL ORDER VALUE:</td>-->
<!--              <td class="text-right">{{totalPrice.toFixed(2).toLocaleString('en')}} PLN</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>TOTAL PIECES:</td>-->
<!--              <td class="text-right">{{totalCount}}</td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div v-else class="text-center mt-3">
      <h5>☝🏻 Select day to search for orders history</h5>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  name: 'MerchantOrderHistory',
  data: () => ({
    user: null,
    loading: false,
    data: [],
    startDate: null,
    scanned: { order: '', code: '' },

    moment,
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  methods: {
    async getOrders() {
      if (!this.startDate) return;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/merchant/merchant-history?day=${moment(this.startDate).format('yyyy-MM-DD')}&user=${this.user.id}`,
          { withCredentials: true },
        );

        if (data && data.length) {
          // assign response to data
          this.data = data.sort((a, b) => {
            if (!a.metaData || !b.metaData) return 0;
            if (a.metaData.toLowerCase() < b.metaData.toLowerCase()) return -1;
            if (a.metaData.toLowerCase() > b.metaData.toLowerCase()) return 1;
            return 0;
          });

          // client separator class flag
          this.data.forEach((row, i) => {
            if (i === 0) {
              this.data[i].border = true;
            } else if (row.metaData && row.metaData.toLowerCase() !== this.data[i - 1].metaData.toLowerCase()) {
              this.data[i].border = true;
            }
          });
        } else {
          throw new Error('No data for selected params');
        }
      } catch (error) {
        this.data = [];
        if (error.response && error.response.status === 401) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻');
        } else {
          this.$toast.error(error?.message); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    getRowClass(row) {
      if (row.notes && !row.noteType) return 'bg-primary';
      if (row.notes && row.noteType === 1) return 'wrong-ean text-white';
      if (row.notes && row.noteType === 2) return 'unavailable-goods text-white';
      if (row.notes && row.noteType === 3) return 'goods-replaced-with text-dark';
      if (row.notes && row.noteType === 4) return 'bg-warning text-dark';

      if (row.count === row.confirmed) return 'bg-success text-dark';
      if (row.count < row.confirmed) return 'bg-warning text-dark';
      return '';
    },
    stripHtmlTags(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
  },
};
</script>

<style>

</style>
